<template>
  <div class="goods">
    <!-- “goods”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
      @chooseClick="searchChooseClick"
      @dblclickEvent="childDblclickEvent"
    ></sirui-search>
    <!-- container -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <!-- <template slot-scope="scope">
            <span v-if="item.field === 'groupCategory'">{{
              transferSelect(scope.row[item.field], groupCategoryOptions)
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template> -->
        </vxe-table-column>
      </sirui-table>
    </div>
    <merge ref="merge"></merge>
    <!-- 上传组件 -->
    <!-- <el-upload
      style="display: none"
      ref="siruiUpload"
      :data="uploadData"
      :action="importUrl"
      accept=".xls, .xlsx"
      :on-success="uploadSuccess"
      :show-file-list="false"
      :with-credentials="true"
      :on-error="uploadError"
    >
      <el-button ref="importBtn"></el-button>
    </el-upload> -->
    <sirui-upload
      :action="action"
      :isShowDownTemplateBtn="true"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/masterData/goods';
  import BASE_API from '@/api/dataBase';
  import merge from '@/pages/masterData/goods/dialog/merge.vue'; // 弹窗
  import loading from '@/common/js/load.js'; //loading
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  import siruiUpload from '@/components/SiruiUpload';
  export default {
    name: 'goods',
    components: {
      SiruiSearch,
      SiruiTable,
      merge,
      siruiUpload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // “中文名称”改为“商品父类名称” sxp update 20210123
            name: '商品名称',
            prop: 'productChName',
            type: 'input',
          },
          {
            // sxp add TAPD ID1001799 20210326
            name: '商品父类编码',
            prop: 'parentProductNo',
            type: 'input',
          },
          // {
          //   // “显示名称”改为“商品子类名称” sxp update 20210123
          //   prop: 'detailProductDisplayName',
          //   name: '商品子类名称',
          //   type: 'searchTable',
          //   width: '800',
          //   page: true,
          //   propCode: 'productDetailCode',
          //   propName: 'detailProductDisplayName',
          //   isMultiple: true,
          //   placeholder: '请输入',
          //   dbclone: true,
          //   trigger: 'click',
          //   query: {
          //     detailProductDisplayName: null,
          //     productDetailCode: null,
          //     detailProductSearchCode: null,
          //     detailProductInvoiceName: null,
          //     adminFlag: this.userInfo.adminFlag,
          //     selectCompanyCode: this.userInfo.companyCode,
          //     selectDepartmentCode: this.userInfo.departmentCode,
          //     //detailProductStatus: 'ZT03'
          //   },
          //   searchColumns: [
          //     {
          //       name: this.$t('goods.search.detailProductDisplayName'),
          //       prop: 'detailProductDisplayName',
          //       type: 'input',
          //       placeholder: '请输入',
          //     },
          //     {
          //       prop: 'productDetailCode',
          //       name: this.$t('goods.search.productDetailCode'),
          //       type: 'input',
          //       placeholder: '请输入',
          //     },
          //     {
          //       name: this.$t('goods.search.detailProductSearchCode'),
          //       prop: 'detailProductSearchCode',
          //       type: 'input',
          //       placeholder: '请输入',
          //     },
          //     {
          //       // 开票名称
          //       name: this.$t('goods.search.detailProductInvoiceName'),
          //       prop: 'detailProductInvoiceName',
          //       type: 'input',
          //       placeholder: '请输入',
          //     },
          //   ],
          //   API: API.LIST_DETAIL_PRODUCT,
          //   columnList: [
          //     {
          //       prop: 'productDetailCode',
          //       label: this.$t('goods.table.productDetailCode'),
          //       width: 160,
          //     },
          //     {
          //       prop: 'detailProductDisplayName',
          //       label: this.$t('goods.table.detailProductDisplayName'),
          //       width: 160,
          //     },
          //     {
          //       prop: 'detailProductSearchCode',
          //       label: this.$t('goods.table.detailProductSearchCode'),
          //       width: 160,
          //     },
          //     {
          //       prop: 'detailProductInvoiceName',
          //       label: this.$t('goods.table.detailProductInvoiceName'),
          //       width: 160,
          //     },
          //     {
          //       prop: 'detailProductStatusName',
          //       label: this.$t('goods.table.detailProductStatus'),
          //       width: 160,
          //     },
          //     {
          //       prop: 'gmtCreate',
          //       label: this.$t('goods.table.gmtCreate'),
          //       width: 160,
          //     },
          //   ],
          //   buttonList: [
          //     {
          //       label: this.$t('goods.button.forbidChild'),
          //       attributes: {
          //         buttonName: this.$t('goods.button.forbidChild'),
          //         buttonUrl: 'forbid',
          //         buttonStyle: '#FE8783',
          //       },
          //       style: '#FE8783',
          //       type: this.userInfo.adminFlag == 1 ? '0' : '1',
          //     },
          //     {
          //       label: this.$t('goods.button.solveForbidChild'),
          //       attributes: {
          //         buttonName: this.$t('goods.button.solveForbidChild'),
          //         buttonUrl: 'solveForbid',
          //         buttonStyle: '#6299fe',
          //       },
          //       type: this.userInfo.adminFlag == 1 ? '0' : '1',
          //     },
          //     {
          //       label: this.$t('goods.button.merge'),
          //       attributes: {
          //         buttonName: this.$t('goods.button.merge'),
          //         buttonUrl: 'merge',
          //         buttonStyle: '#6299fe',
          //       },
          //       type: this.userInfo.adminFlag == 1 ? '0' : '1',
          //     },
          //     {
          //       label: '批准',
          //       attributes: {
          //         buttonName: '批准',
          //         buttonUrl: 'approval',
          //         buttonStyle: '#6299fe',
          //       },
          //       type: this.userInfo.adminFlag == 1 ? '0' : '1',
          //     },
          //     {
          //       label: '驳回',
          //       attributes: {
          //         buttonName: '驳回',
          //         buttonUrl: 'reject',
          //         buttonStyle: '#6299fe',
          //       },
          //       type: this.userInfo.adminFlag == 1 ? '0' : '1',
          //     },
          //   ],
          // },
          {
            name: '开始时间',
            prop: 'startDate',
            type: 'startDaterangePicker',
          },
          {
            name: '结束时间',
            prop: 'endDate',
            type: 'endDaterangePicker',
            flag: 1,
          },
          // {
          //   name: this.$t('goods.search.parentProductStatus'),
          //   prop: 'parentProductStatus',
          //   type: 'select',
          //   options: this.statusOptions,
          // },
          // {
          //   name: this.$t('goods.search.groupCategory'),
          //   prop: 'groupCategory',
          //   type: 'select',
          //   options: this.groupCategoryOptions,
          // },
          {
            name: '商品分类',
            prop: 'groupCategory',
            type: 'treeSelect',
            options: this.groupCategoryOptions,
            apiUrl: this.groupCategoryUrl,
            isName: false,
            clearable: false,
          },
          {
            name: '搜索简码',
            prop: 'productSearchCode',
            type: 'input',
          },
          {
            name: '创建人',
            prop: 'createBy',
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            name: '审核状态',
            prop: 'parentProductStatus',
            type: 'select',
            options: this.statusOptions,
          },
          // {
          //   prop: 'departmentCode',
          //   name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
          //   placeholder: this.$t('payablesBillList.search.departPlaceholder'),
          //   type: 'select',
          //   options: this.departmentList,
          // },
          // {
          //   type: 'searchTableSpec',
          //   prop: 'requestPerson',
          //   searchType: 'personnel',
          //   isMultiple: true,
          //   name: '申请人',
          // },
        ];
      },
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
    },
    data() {
      return {
        groupCategoryUrl: BASE_API.GET_PRODUCT_CAT_TREE,
        load: false,
        // 表格展示字段
        columnList: [],
        companyList: [],
        departmentList: [],
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'parentProductNo',
            title: '商品父类编码',
            visible: true,
          },
          { field: 'productChName', title: '商品名称', visible: true },
          { field: 'productSearchCode', title: '搜索简码', visible: true },
          // { field: 'productEnName', title: 'goods.table.productEnName', visible: true },
          { field: 'groupCategory', title: '商品分类', visible: true },
          // { field: 'departmentName', title: 'goods.table.departmentName', visible: true },
          // { field: 'requestPerson', title: 'goods.table.requestPerson', visible: true },
          // {
          //   field: 'parentProductStatusName',
          //   title: 'goods.table.parentProductStatusName',
          //   visible: true,
          // },
          { field: 'createByName', title: '创建人', visible: true },
          { field: 'parentProductStatusName', title: '审核状态', visible: true },
          { field: 'gmtCreate', title: '创建时间', visible: true },
        ],
        query: {
          startDate: null,
          endDate: null,
          // partnerType: null,
          // requestStatus: null,
          // partnerproductChName: null,
          departmentCode: null,
          // requestPerson: null,
          parentProductNo: null,
          productSearchCode: null,
          productChName: null,
          groupCategory: null,
          createBy: null,
          parentProductStatus: null,
        },
        statusOptions: [],
        groupCategoryOptions: [],
        menuButtonList: [],
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        uploadData: {}, // 上传参数columnList
        importUrl: '',
        saveChooseClickData: [], //暂存子类选中数据
        action: API.PRODUCT_IMPORT,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getdepartmentList();
        this.getButtonList();
        this.getStatusOptions(); //通过数据字典获取状态下拉
        this.getGroupCategoryOptions(); //通过数据字典获取集团产品分类下拉
        this.setImport();
        this.query.endDate = this.getDate();
      });
    },
    watch: {
      $route() {
        this.getData();
      },
    },
    methods: {
      // 获取部门
      getdepartmentList() {
        const companyCode = this.userInfo.companyCode;
        this.$axios.post(BASE_API.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 获取当前时间
      getDate() {
        let date = new Date();
        let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
        return date.getFullYear() + '-' + month + '-' + day;
      },
      //各种下拉转化
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          if (this.userInfo.adminFlag === 1) {
            this.menuButtonList = e || [];
          } else {
            // const onlyArr = ['add', 'addChildren', 'export', 'import'];
            const onlyArr = ['add', 'addChildren'];
            this.menuButtonList = e.filter((item) =>
              onlyArr.includes(item.attributes.buttonUrl || '')
            );
          }
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
          this.columnList.forEach((item) => {
            if (item.field == 'groupCategory') {
              item.field = 'groupCategoryName';
            }
          });
        });
      },
      getData() {
        const {
          startDate,
          endDate,
          productChName,
          parentProductStatus,
          parentProductNo,
          groupCategory,
          departmentCode,
          productSearchCode,
          // requestPerson,
          detailProductDisplayName,
          createBy,
        } = this.query;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag } = this.userInfo;
        const selectCompanyCode = this.userInfo.companyCode;
        let productDetailCodes = '';
        let productDetailCodesArr = [];
        if (detailProductDisplayName) {
          detailProductDisplayName.map((item) => {
            productDetailCodesArr.push(item.productDetailCode);
          });
        }
        productDetailCodes = productDetailCodesArr.join(',');
        const params = {
          startDate,
          endDate,
          productChName,
          parentProductStatus,
          parentProductNo,
          groupCategory,
          productDetailCodes: productDetailCodes,
          pageNum,
          pageSize,
          adminFlag,
          departmentCode,
          requestPerson: this.query.requestPerson ? this.query.requestPerson[0].personName : '',
          selectCompanyCode: selectCompanyCode,
          productSearchCode,
          // createBy: createBy == 'null' ? '' : createBy[0].id || '',
        };
        if (createBy) {
          params.createBy = createBy[0].id || '';
        }

        this.$axios.post(API.LIST_PRODUCT, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = Object.freeze(res.data.data.list);
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      //获取状态下拉
      getStatusOptions() {
        const params = {
          dictType: 'request_status',
          tenantCode: this.userInfo.tenantCode,
        };
        this.$axios.post(API.DATA_DICT, params).then((res) => {
          if (res.data.code === 0) {
            this.statusOptions = res.data.data;
          }
        });
      },
      //获取集团产品下拉分类
      getGroupCategoryOptions() {
        const params = {
          dictType: 'group_category',
          tenantCode: this.userInfo.tenantCode,
        };
        this.$axios.post(API.DATA_DICT, params).then((res) => {
          if (res.data.code === 0) {
            this.groupCategoryOptions = res.data.data;
            // this.groupCategoryOptions.map((item) => {
            //   item.value = item.dataValue;
            //   item.label = item.dataName;
            // })
          }
        });
      },
      //双击跳转到新增页面
      chooseClick(type) {
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();

        if (type === 'add') {
          let path = {
            path: '/masterData/addGoods',
            name: 'addGoods',
            meta: {
              keepAlive: false,
              title: this.$t('goods.titile.addGoods'),
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'enable') {
          // 启用
          this.handleEnable();
        } else if (type === 'forbid') {
          //禁用
          this.handleForbid();
        } else if (type === 'addChildren') {
          //新增商品详细数据
          this.handleAddChildren();
        } else if (type === 'export') {
          //导出
          this.handleExport();
        } else if (type === 'import') {
          //导入
          this.handleImport();
        } else if (type === 'reject') {
          this.handleReject('0');
        } else if (type === 'approval') {
          this.handleReject('1');
        }
      },
      handleReject(val) {
        if (this.resolveSelected('more')) {
          // 可多选
          let isRequestStatus = this.multipleSelection.every(
            (item) => item.parentProductStatus == 'ZT02'
          );
          let idList = [];
          this.multipleSelection.forEach((item) => {
            if (item.parentProductStatus == 'ZT02') {
              idList.push(item.id);
            }
          });
          if (isRequestStatus) {
            let params = {
              businessIds: idList,
              approvaResult: val,
            };
            loading.startLoading();
            this.$axios.post(API.UPDATE_IS_REJECT, params).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                this.$refs.siruiTable.clearCheckboxReserve();
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.getData();
                this.multipleSelection = [];
              } else {
                this.$alert(res.data.msg);
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('goods.message.importError'),
              type: 'error',
            });
          }
        }
      },
      // 列表双击
      dblclickEvent(value) {
        let path = {
          path: '/masterData/goodsDetail',
          name: 'goodsDetail',
          meta: {
            keepAlive: false,
            title: this.$t('goods.titile.goodsDetail'),
          },
          query: {
            propsGoodsId: value.row.id,
          },
        };
        if (value.row.parentProductStatus == 'ZT06') {
          //草稿
          path.path = '/masterData/editGoods';
          path.name = 'editGoods';
          path.meta.title = this.$t('goods.titile.editGoods');
        }
        // 针对物贸板块
        if (value.row.parentProductStatus == 'ZT02' && this.userInfo.businessGroup == '物贸') {
          console.log('审批状态', value.row.parentProductStatus, this.userInfo.businessGroup);
          path.query.from = 'todo';
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //双击子类搜索列表行
      childDblclickEvent(value) {
        let path = {
          path: '/masterData/goodsDetail',
          name: 'goodsDetail',
          meta: {
            keepAlive: true,
            title: this.$t('goods.titile.goodsDetail'),
          },
          query: {
            propsGoodsId: value.row.pid,
            productDetailCode: value.row.productDetailCode,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 表格选择行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.log(column, property, order);
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 重置
      resetBtnClick() {
        this.query.endDate = this.getDate();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.getData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getData();
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('goods.tip.noneChoose'),
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: this.$t('goods.tip.placeChooseOne'),
            type: 'error',
          });
          return false;
        }
        return true;
      },
      resolveChildSelected(type, arr) {
        if (arr.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('goods.tip.noneChoose'),
            type: 'error',
          });
          return false;
        } else if (arr.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: this.$t('goods.tip.placeChooseOne'),
            type: 'error',
          });
          return false;
        }
        return true;
      },
      // 启用
      handleEnable() {
        if (this.resolveSelected('more')) {
          // 判断选中数据是否有不是禁用的
          let hasErrorStatus = false;
          this.multipleSelection.map((item) => {
            if (item.parentProductStatus != 'ZT04') {
              hasErrorStatus = true;
            }
          });
          if (hasErrorStatus) {
            this.$message({
              showClose: true,
              message: '只能启用已禁用状态的数据,请重新选择',
              type: 'error',
            });
            return;
          }
          let params = {
            forbidFlag: 0,
          };
          let ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push({ id: item.id, version: item.version, parentProductNo: item.parentProductNo });
          });
          params.ids = JSON.stringify(ids);
          this.$axios.post(API.PRODUCT_STATUS_UPDATE, params).then((res) => {
            if (res.data.code === 0) {
              this.getData();
              this.$refs.siruiTable.clearCheckboxReserve();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      // 禁用
      handleForbid() {
        if (this.resolveSelected('more')) {
          //判断选中数据是否有不是生效状态的
          let hasErrorStatus = false;
          this.multipleSelection.map((item) => {
            if (item.parentProductStatus != 'ZT03') {
              //有不是已生效不能禁用操作
              hasErrorStatus = true;
            }
          });
          if (hasErrorStatus) {
            this.$message({
              showClose: true,
              message: '只能禁用已生效的数据,请重新选择',
              type: 'error',
            });
            return;
          }
          var params = {
            forbidFlag: 1,
          };
          var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push({ id: item.id, version: item.version, parentProductNo: item.parentProductNo });
          });
          params.ids = JSON.stringify(ids);
          this.$axios.post(API.PRODUCT_STATUS_UPDATE, params).then((res) => {
            if (res.data.code === 0) {
              this.getData();
              this.$refs.siruiTable.clearCheckboxReserve();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else if (res.data.code === 10000) {
              //强制禁用
              this.$repeatAlert(
                "<div><img src='./static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  res.data.msg +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('goods.message.forciblyDisable'),
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      params.forceFlag = 0;
                      this.$axios.post(API.PRODUCT_STATUS_UPDATE, params).then((res) => {
                        if (res.data.code === 0) {
                          this.getData();
                          this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'success',
                          });
                        } else {
                          this.$message({ showClose: true, type: 'error', message: res.data.msg });
                        }
                      });
                    }
                  },
                }
              );
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      //子类启用禁用
      handleDetailForbid(arr, val) {
        if (this.resolveChildSelected('more', arr)) {
          var params = {
            forbidFlag: val,
          };
          var ids = [];
          arr.forEach((item) => {
            ids.push({
              id: item.id,
              productDetailCode: item.productDetailCode,
              version: item.version,
            });
          });
          params.ids = JSON.stringify(ids);
          this.$axios.post(API.DETAIL_PRODUCT_STATUS_UPDATE, params).then((res) => {
            if (res.data.code === 0) {
              this.$refs.siruiSearch.uploadData();
              //禁用成功后选中暂存数据更新uploadData
              let newVersion = this.$refs.siruiSearch.returnTableData().tableData.filter((item) => {
                return item.id == this.saveChooseClickData[0].id;
              });
              if (val == 1) {
                this.saveChooseClickData[0].version = newVersion[0].version + 1;
                this.saveChooseClickData[0].detailProductStatus = 'ZT04';
              } else if (val == 0) {
                this.saveChooseClickData[0].version = newVersion[0].version + 1;
                this.saveChooseClickData[0].detailProductStatus = 'ZT03';
              }
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            } else if (res.data.code === 10000) {
              //强制禁用
              this.$repeatAlert(
                "<div><img src='/static/img/tips.png'/>" +
                  "<div class='repeatContent'>" +
                  res.data.msg +
                  '</div></div>',
                '',
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: this.$t('goods.message.forciblyDisable'),
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      params.forceFlag = 0;
                      this.$axios.post(API.DETAIL_PRODUCT_STATUS_UPDATE, params).then((res) => {
                        if (res.data.code === 0) {
                          this.getData();
                          this.$refs.siruiSearch.uploadData();
                          //禁用成功后选中暂存数据更新uploadData
                          let newVersion = this.$refs.siruiSearch
                            .returnTableData()
                            .tableData.filter((item) => {
                              return item.id == this.saveChooseClickData[0].id;
                            });
                          if (val == 1) {
                            this.saveChooseClickData[0].version = newVersion[0].version + 1;
                            this.saveChooseClickData[0].detailProductStatus = 'ZT04';
                          } else if (val == 0) {
                            this.saveChooseClickData[0].version = newVersion[0].version + 1;
                            this.saveChooseClickData[0].detailProductStatus = 'ZT03';
                          }
                          this.$message({
                            showClose: true,
                            message: res.data.msg,
                            type: 'success',
                          });
                        } else {
                          this.$message({ showClose: true, type: 'error', message: res.data.msg });
                        }
                      });
                    }
                  },
                }
              );
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      //添加详细
      handleAddChildren() {
        if (this.resolveSelected()) {
          if (
            this.multipleSelection[0].parentProductStatus == 'ZT04' ||
            this.multipleSelection[0].parentProductStatus == 'ZT02'
          ) {
            this.$message({
              showClose: true,
              message: '请选择一条非禁用和非审批中状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          let path = {
            path: '/masterData/addDetailGoods',
            name: 'addDetailGoods',
            meta: {
              keepAlive: false,
              title: this.$t('goods.titile.addDetailGoods'),
            },
            query: {
              propsGoodsId: this.multipleSelection[0].id,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      //子类批准驳回
      handApprovalChildren(val, ...ids) {
        let params = {
          businessIds: ids,
          approvaResult: val,
        };
        loading.startLoading();
        this.$axios.post(API.UPDATE_IS_CHILDREN_REJECT, params).then((res) => {
          loading.endLoading();
          if (res.data.code === 0) {
            this.$refs.siruiSearch.uploadData();
            let newVersion = this.$refs.siruiSearch.returnTableData().tableData.filter((item) => {
              return item.id == this.saveChooseClickData[0].id;
            });
            if (val == 1) {
              this.saveChooseClickData[0].version = newVersion[0].version + 1;
              this.saveChooseClickData[0].detailProductStatus = 'ZT03';
            } else if (val == 0) {
              this.saveChooseClickData[0].version = newVersion[0].version + 1;
              this.saveChooseClickData[0].detailProductStatus = '"ZT05"';
            }
            this.$message({
              showClose: true,
              message: res.data.msg || '操作成功',
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //搜索下拉按钮最终抛出
      searchChooseClick(btnUrl, arr) {
        let resetFlag = this.$refs.siruiSearch.returnTableData().resetFlag;
        if (this.saveChooseClickData.length == 0 || arr[0].id != this.saveChooseClickData[0].id) {
          this.saveChooseClickData = JSON.parse(JSON.stringify(arr));
        }
        if (resetFlag) {
          this.saveChooseClickData = arr;
          this.$refs.siruiSearch.returnTableDatas();
        }
        if (!this.resolveChildSelected('', this.saveChooseClickData)) return;
        if (btnUrl == 'merge') {
          if (this.saveChooseClickData[0].detailProductStatus != 'ZT03') {
            //不等于已生效不能合并操作
            this.$message({
              showClose: true,
              message: '请选择一条已生效状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          //合并
          this.$refs.merge.openDialog(this.saveChooseClickData[0]);
        } else if (btnUrl == 'forbid') {
          if (this.saveChooseClickData[0].detailProductStatus != 'ZT03') {
            //不等于已生效不能禁用操作
            this.$message({
              showClose: true,
              message: '请选择一条已生效状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          //禁用
          this.handleDetailForbid(this.saveChooseClickData, 1);
        } else if (btnUrl == 'solveForbid') {
          //解禁用
          if (this.saveChooseClickData[0].detailProductStatus != 'ZT04') {
            //不等于已生效不能禁用操作
            this.$message({
              showClose: true,
              message: '请选择一条已禁用状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          this.handleDetailForbid(this.saveChooseClickData, 0);
        } else if (btnUrl == 'approval') {
          //审批
          if (this.saveChooseClickData[0].detailProductStatus != 'ZT02') {
            //不等于审批中不能批准操作
            this.$message({
              showClose: true,
              message: '请选择一条审批中状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          this.handApprovalChildren(1, this.saveChooseClickData[0].id);
        } else if (btnUrl == 'reject') {
          //驳回
          if (this.saveChooseClickData[0].detailProductStatus != 'ZT02') {
            //不等于审批中不能驳回操作
            this.$message({
              showClose: true,
              message: '请选择一条审批中状态的数据进行操作',
              type: 'error',
            });
            return;
          }
          this.handApprovalChildren(0, this.saveChooseClickData[0].id);
        }
      },
      // 导出
      handleExport() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const columns = this.$refs.siruiTable.getTableColumn().visibleColumn; // 获取当前展示列
        const columnsList = [];
        for (var el of columns) {
          if (el.property) {
            // 排除checkbox选框
            let resultList = this.columnList.filter((item) => {
              return item.prop == el.property;
            });
            if (resultList.length) columnsList.push(resultList[0]);
          }
        }
        const {
          startDate,
          endDate,
          productChName,
          parentProductStatus,
          parentProductNo,
          groupCategory,
          departmentCode,
          detailProductDisplayName,
        } = this.query;
        const params = {
          startDate,
          endDate,
          productChName,
          parentProductStatus,
          parentProductNo,
          groupCategory,
          departmentCode,
          requestPerson: this.query.requestPerson ? this.query.requestPerson[0].personName : '',
          detailProductDisplayName,
        };
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            ids.push(item.id);
          });
        }
        params.adminFlag = this.userInfo.adminFlag;
        params.selectCompanyCode = this.userInfo.companyCode;
        params.columns = JSON.stringify(columnsList);
        params.ids = ids.join(',');
        this.$axios.post(API.PRODUCT_EXPORT, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      setImport() {
        this.importUrl = `${baseUrl ? baseUrl : 'http://192.168.50.183:8088/'}${
          API.PRODUCT_IMPORT
        }`;
        this.importData = {
          tenantCode: this.userInfo.tenantCode,
          access_token: this.userInfo.access_token,
        };
      },
      //导入
      handleImport() {
        console.log('导入商品数据');
        this.$refs.SiruiUpload.openDialog(true, '100');
        // const {
        //   access_token,
        //   tenantCode,
        //   companyCode,
        //   departmentCode,
        //   companyName,
        //   departmentName,
        // } = this.userInfo;
        // this.uploadData = {
        //   access_token,
        //   tenantCode,
        //   companyCode,
        //   departmentCode,
        //   companyName,
        //   departmentName,
        //   requestPerson: this.userInfo.userName,
        //   lang: this.lang,
        // };
        // this.$refs.importBtn.$el.click();
      },
      // 上传成功
      uploadSuccess(response) {
        if (response.code === 0) {
          this.$message({ showClose: true, message: response.msg, type: 'success' });
          this.getData();
        } else {
          this.$message({ showClose: true, message: response.msg, type: 'error' });
        }
        if (response.data) {
          //有返回的文件地址 进行下载
          window.location.href = response.data;
        }
      },
      // 上传错误
      uploadError() {
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
    },
  };
</script>

<style scoped></style>
